<template>
  <div class="user-details-edit">
    <user-details-edit-card :user="user"
                            @submit="onSubmit">
    </user-details-edit-card>
  </div>
</template>
<script>
  import UserDetailsEditCard from './UserDetailsEditCard'
  import UserService from 'src/services/UserService'

  export default {
    name: 'user-details-edit',
    components: {
      UserDetailsEditCard
    },
    data () {
      return {
        user: {}
      }
    },
    methods: {
      async onSubmit (id, data) {
        await UserService.update(id, data)
      }
    },
    async beforeRouteEnter (to, from, next) {
      try {
        let id = to.params.id
        let res = await UserService.getById(id)
        let user = res.data
        if (user) {
          next(vm => {
            vm.user = user
          })
        } else {
          next(vm => vm.error = 'No data')
        }
      } catch (e) {
        next(vm => vm.error = e)
      }
    }
  }
</script>
